import React from "react";
import BaseComponent from "../BaseComponent";
import styled, { css } from "styled-components";
import nota from "../Global/nota.guidelines.json";
import NanoFlex from "../Global/NanoFlex.js";
// import playlistService from "../../services/PlaylistService.js";

import Button from "../Nano/Buttons/Button.js";
// import Spinner from "../Nano/Spinner.js";
import Type from "../Global/Typography.js";
import Input from "../Nano/Input.js";
import Dropdown from "../Nano/Dropdown.js";

//IMAGES
import { ReactComponent as SearchIcon } from "../Global/Icons/search.svg";
import { ReactComponent as Share } from "../Global/Icons/share.svg";
import { ReactComponent as Delete } from "../Global/Icons/delete.svg";

import NotaIcon from "../Global/Icons/nota-icon.svg";

import playlistService from "../../services/PlaylistService.js";

const multiple = nota.global.multiple;

const SharePlaylistModalStyle = styled.div`
  width: 500px;
  background-color: ${nota.color.neutral.white};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  padding: ${multiple * 3 + "px"};
  .headerModal {
    padding-bottom: ${multiple + "px"};
    border-bottom: 0.5px solid ${nota.color.neutral.NeuFour};
    svg {
      height: 16px;
      width: 16px;
      path {
        fill: ${nota.color.main.default};
      }
    }
    h3 {
      margin-left: ${multiple + "px"};
      text-transform: uppercase;
      b {
        color: ${nota.color.main.default};
      }
    }
  }
  .modalContainer {
    .modalWrapper {
      padding: ${multiple * 3 + "px"} 0;
      position: relative;

      .selectAllWrapper {
        margin-bottom: 8px;
        user-select: none;
        p {
          cursor: pointer;
          color: ${(props) => (props.isAllSelected ? nota.color.main.default : nota.color.neutral.NeuOne)};
          &:hover {
            color: ${nota.color.main.default};
          }
        }
      }
    }
  }
  .loadingContainer {
    min-height: 363px;
  }
  /* INPUT SEARCH */
  .inputWrapperModal {
    width: 100%;
    position: relative;
    .inputContainer {
      width: 100%;
      margin: 0;
      .inputWrapper {
        width: 100%;
        input {
          padding-right: 40px;
        }
      }
    }
    .searchIconWrapper {
      position: absolute;
      right: ${multiple + "px"};
      top: 0;
      width: ${multiple * 3 + "px"};
      svg {
        width: 18px;
        height: 18px;
        path {
          fill: ${nota.color.main.default};
        }
      }
    }
  }
  .btnsContainer {
    padding: 16px 8px 0 8px;
    border-top: 0.5px solid ${nota.color.neutral.NeuFour};
    .cta {
      margin: 0;
    }
  }

  /* .dropDownWrapper {
    .dropdown-content {
      position: absolute;
      left: 50%;
      transform: translate(-50%);
    }
  } */

  /* LIST */
  .listModal {
    margin-top: ${multiple + "px"};
    overflow: auto;
    padding: ${multiple + "px"};
    background: ${nota.color.neutral.lightGrey};
    height: 220px;
    background-image: url(${NotaIcon});
    background-repeat: no-repeat, repeat;
    background-size: 50% 50%;
    background-position: center;
  }

  /* ITEM */
  .itemContainerModal {
    background-color: ${nota.color.neutral.white};
    padding: ${multiple + "px"} ${multiple * 2 + "px"};
    height: auto;
    border: 1px solid #f2f2f2;
    margin-bottom: 4px;
    min-height: -webkit-fit-content;
    .userWrapper {
      .userIconWrapper {
        width: 46px;
        height: 40px;
        border-radius: 100px;
        background-color: ${nota.color.main.default};
        user-select: none;
        h3 {
          b {
            color: ${nota.color.neutral.white};
            text-transform: uppercase;
          }
        }
      }
      .userInfoWrapper {
        text-align: left;
        margin-left: ${multiple * 2 + "px"};
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        p {
          margin-bottom: ${multiple / 2 + "px"};
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    .optionsWrapper {
      width: auto;
      user-select: none;
      .iconWrapper {
        cursor: pointer;
        .deleteIcon {
          height: 14px;
          width: auto;
          path {
            fill: ${nota.color.neutral.NeuOne};
          }
        }
        &:hover {
          .deleteIcon {
            path {
              fill: ${nota.color.main.mTwo};
            }
          }
        }
      }
    }
    &:last-child {
      margin-bottom: 8px;
    }
  }

  /* DROPDOWN */
  .dropdown-content {
    margin: 0;
    width: 100%;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border: 1px solid ${nota.color.neutral.NeuTwo};
    user-select: none;
    .listContainerModal {
      max-height: 200px;
      overflow: auto;
      .itemContainerModal {
        cursor: pointer;
        margin-bottom: 0;
      }
    }
  }
  .noResults {
    user-select: none;
    padding: ${multiple + "px"};
  }
  /* MEDIA QUERIES */
  @media only screen and (max-width: 520px) {
    /* width: 100%; */
    width: 90vw;
    .listContainerModal {
      .itemContainerModal {
        padding: ${multiple + "px"};
        .userWrapper {
          width: calc(70vw - 24px);
          .userIconWrapper {
            width: 20px;
            height: 20px;
            padding: 12px;
            h3 {
              font-size: 12px;
            }
          }
          .userInfoWrapper {
            margin-left: ${multiple + "px"};
          }
        }
      }
    }
    .btnsContainer {
      flex-direction: column;
      .buttonWrapper {
        order: 1;
      }
      .simpleButtonWrapper {
        order: 2;
        margin-top: ${multiple + "px"};
      }
    }
  }
  @media only screen and (max-width: 320px) {
    .listContainerModal {
      .itemContainerModal {
        .userWrapper {
          width: calc(70vw - 38px);
        }
      }
    }
  }
`;

export class SharePlaylistModal extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      users: null,
      isOpen: false,
      term: "",
      selectedUsers: [],
    };
  }

  componentDidMount = () => {
    this.getUsers();
  };

  getUsers = () => {
    playlistService
      .getSharedPlaylistUsers(this.props.playlistId, false)
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          // Catch
          if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((data) => {
        this.setState({ users: data });
      });
  };

  cancelShare = () => {
    if (this.props.cancelAction) this.props.cancelAction();
  };

  addToSelected = (item) => {
    this.setState({
      isOpen: false,
      users: this.state.users.filter((u) => {
        return u.idUser !== item.idUser;
      }),
      selectedUsers: [...this.state.selectedUsers, item],
    });
  };

  removeFromSelected = (item) => {
    this.setState({
      users: [...this.state.users, item],
      selectedUsers: this.state.selectedUsers.filter((u) => {
        return u.idUser !== item.idUser;
      }),
    });
  };

  onTermChange = (value) => {
    this.setState({ term: value });
  };

  getFilteredResults = () => {
    if (this.state.term.trim() !== "") {
      let upperTerm = this.state.term.trim().toUpperCase();
      return this.state.users.filter((v) => {
        let upperVal = (v.email ?? v.username).trim().toUpperCase();
        return upperVal.startsWith(upperTerm);
      });
    } else {
      return this.state.users;
    }
  };

  share = () => {
    playlistService
      .linkMultipleSharedPlaylist(
        this.props.playlistId,
        this.state.selectedUsers.map((item) => {
          return item.idUser;
        })
      )
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          // Catch
          if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((data) => {
        /*Trigger playlistsChange Event */
        window.dispatchEvent(new Event("playlistsChange"));

        if (this.props.nextAction) this.props.nextAction();
      });
  };

  isAllSelected = () => {
    return this.state.users?.length === 0;
  };

  onSelectAllClick = () => {
    if (!this.isAllSelected()) {
      this.setState({
        users: [],
        selectedUsers: [...this.state.selectedUsers, ...this.state.users],
      });
    } else {
      this.setState({
        users: [...this.state.selectedUsers, ...this.state.users],
        selectedUsers: [],
      });
    }
  };

  render() {
    let filteredResults = this.getFilteredResults() ?? [];

    return (
      <SharePlaylistModalStyle isAllSelected={this.isAllSelected()}>
        <NanoFlex className="headerModal" justifyContent="flex-start">
          <Share />
          <Type.h3>
            <b>{this.translation.components.sharePlaylistModal.title}</b>
          </Type.h3>
        </NanoFlex>

        {/* <NanoFlex className="loadingContainer">
          <Spinner />
        </NanoFlex> */}

        <NanoFlex className="modalContainer" flexDirection={"column"} justifyContent="space-between" alignContent="space-between">
          <NanoFlex className="modalWrapper" flexDirection={"column"}>
            <NanoFlex className="selectAllWrapper" justifyContent="flex-end">
              <Type.p onClick={this.onSelectAllClick}>{this.translation.components.sharePlaylistModal.selectAll}</Type.p>
            </NanoFlex>
            <Dropdown
              isOpen={this.state.isOpen}
              onChangeToggle={(isOpen) => this.setState({ isOpen: isOpen })}
              onClickOutsideClose
              main={
                <NanoFlex className="inputWrapperModal" justifyContent={"flex-start"} alignContent={"flex-start"} alignItems={"flex-start"}>
                  <Input title={null} defaultValue={this.state.term} placeholder={this.translation.components.sharePlaylistModal.shareWith} onChangeAction={this.onTermChange} />
                  <NanoFlex className="searchIconWrapper">
                    <SearchIcon />
                  </NanoFlex>
                </NanoFlex>
              }
              content={
                <NanoFlex className="listContainerModal" flexDirection={"column"} justifyContent={"flex-start"} alignItems={"flex-start"}>
                  {filteredResults.length == 0 && (
                    <NanoFlex className="noResults">
                      <Type.p>No Results Found</Type.p>
                    </NanoFlex>
                  )}
                  {filteredResults.map((item) => {
                    let val = item.email ?? item.username;

                    return (
                      <NanoFlex
                        className="itemContainerModal"
                        justifyContent={"space-between"}
                        onClick={() => {
                          this.addToSelected(item);
                        }}>
                        <NanoFlex className="userWrapper">
                          <NanoFlex className="userIconWrapper">
                            <Type.h3>
                              <b>{val[0]}</b>
                            </Type.h3>
                          </NanoFlex>
                          <NanoFlex className="userInfoWrapper" flexDirection={"column"} alignItems={"flex-start"}>
                            <Type.p>{val}</Type.p>
                          </NanoFlex>
                        </NanoFlex>
                      </NanoFlex>
                    );
                  })}
                </NanoFlex>
              }
            />

            <NanoFlex className="listModal" justifyContent={"flex-start"} alignItems={"flex-start"}>
              {/*LIST*/}
              <NanoFlex className="listContainerModal" flexDirection={"column"} justifyContent={"flex-start"} alignItems={"flex-start"}>
                {/* ITEM  */}
                {this.state.selectedUsers &&
                  this.state.selectedUsers.map((item) => {
                    let val = item.email ?? item.username;

                    return (
                      <NanoFlex className="itemContainerModal" justifyContent={"space-between"}>
                        <NanoFlex className="userWrapper" justifyContent={"flex-start"}>
                          <NanoFlex className="userIconWrapper">
                            <Type.h3>
                              <b>{val[0]}</b>
                            </Type.h3>
                          </NanoFlex>
                          <NanoFlex className="userInfoWrapper" flexDirection={"column"} alignItems={"flex-start"}>
                            <Type.p>{val}</Type.p>
                          </NanoFlex>
                        </NanoFlex>
                        <NanoFlex className="optionsWrapper">
                          <NanoFlex
                            className="iconWrapper"
                            onClick={() => {
                              this.removeFromSelected(item);
                            }}>
                            <Delete className="deleteIcon" />
                          </NanoFlex>
                        </NanoFlex>
                      </NanoFlex>
                    );
                  })}
                {/* END ITEM  */}
              </NanoFlex>
              {/* END LIST  */}
            </NanoFlex>
          </NanoFlex>

          <NanoFlex className="btnsContainer" alignContent={"flex-end"}>
            <Button label={this.translation.geral.cancel} simple clickAction={this.cancelShare} />
            <Button label={this.translation.geral.confirm} clickAction={this.share} disable={this.state.selectedUsers.length == 0} />
          </NanoFlex>
        </NanoFlex>
      </SharePlaylistModalStyle>
    );
  }
}

// Set default props
SharePlaylistModal.defaultProps = {
  cancelAction: () => null,
  nextAction: () => null,
};

export default SharePlaylistModal;

/*
  Doc
  import SharePlaylistModal from '../../Micro/Warning.js';
  
  <SharePlaylistModal
      cancelAction={() => console.log('cancelAction')}
      nextAction={() => console.log('nextAction')}
  />
  */
